export const authLocales = {
  vi: {
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    signIn: 'Đăng nhập',
    signUp: 'Đăng ký',
    signOut: 'Đăng xuất',
    loginWithGoogle: 'Đăng nhập với Google',
    loginWithFacebook: 'Đăng nhập với Facebook',
    loginWithUsername: 'Đăng nhập bằng Tên đăng nhập',
    loginWithPhoneNumber: 'Đăng nhập bằng Số điện thoại',
    enterOTP: 'Xác thực OTP',
    zaloOtpNote: 'Nhập mã gồm 4 chữ số đã được gửi đến tài khoản Zalo có SĐT',
    smsOtpNote: 'Nhập mã gồm 4 chữ số đã được gửi đến tin nhắn SĐT',
    sentOtpNote: 'Nhập mã gồm 4 chữ số đã được gửi đến số điện thoại ',
    resendOtpIn: 'Gửi lại mã sau ',
    didNotReceiveOtp: 'Bạn không nhận được mã?',
    resendOtp: 'Gửi lại mã OTP',
    loggingInWithPhoneNumber: 'Nhập mật khẩu để đăng nhập với số điện thoại ',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    phoneNumber: 'Số điện thoại',
    enterYourPhoneNumber: 'Nhập số điện thoại của bạn',
    fullName: 'Tên đầy đủ',
    chooseYourAccountType: 'Chọn loại tài khoản',
    referralCode: 'Mã giới thiệu',
    conditionAndPolicyMessage:
      "Bằng cách nhấp vào Đăng ký, bạn đồng ý với <a target='_blank' href='https://ahamove.com/pages/policy' title='{{terms}}' >{{terms}}</a> của chúng tôi",
    termsAndConditions: 'Điều khoản và Chính sách',
    phonePlaceholder: 'Số điện thoại để tài xế liên lạc với bạn',
    namePlaceholder: 'Tên liên lạc của bạn khi sử dụng dịch vụ',
    emailPlaceholder: 'Nhận mọi thông tin từ chúng tôi qua email',
    optional: 'không bắt buộc',
    referralPlaceholder: 'Nhận ngay ưu đãi khi nhập mã',
    privacyPolicyAndTermsOfService:
      'Bằng việc nhấp vào Đăng ký, bạn đồng ý với ',
    privacyPolicyAndTermsOfServiceLink:
      'Chính sách bảo mật và Điều khoản sử dụng của Ahamove',
    // privacyPolicyAndTermsOfService:
    //   'Bằng việc nhấp vào Đăng ký, bạn đồng ý với <link>Chính sách bảo mật và Điều khoản sử dụng của Ahamove</link>.',
    thisAccountDoesNotExist: 'Không tìm thấy tài khoản',
    // thisAccountDoesNotExistHint:
    //   'Số điện thoại <bold>{phoneNumber}</bold> chưa đăng ký tài khoản Ahamove, bạn có muốn đăng ký không?',
    thisAccountDoesNotExistHintPhoneNumber: 'Số điện thoại',
    thisAccountDoesNotExistHintQuestion:
      'chưa đăng ký tài khoản Ahamove, bạn có muốn đăng ký không?',
    requiredPhoneNumber: 'Vui lòng nhập số điện thoại',
    invalidPhoneNumber: 'Số điện thoại không hợp lệ',
    requiredEmail: 'Vui lòng nhập Email',
    requiredName: 'Vui lòng nhập tên',
    yourTokenHasExpiredPleaseSignInAgain:
      'Token của bạn đã hết hạn, vui lòng đăng nhập lại.',
    yourTokenHasExpired: 'Token của bạn đã hết hạn.',
    youAreNotLoggedInYet: 'Bạn ơi bạn chưa đăng nhập!',
    pleaseLogInToContinue: 'Bạn hãy đăng nhập để tiếp tục nhé.',
    enterPassword: 'Nhập mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    resetPassword: 'Khôi phục mật khẩu',
    resetYourPassword: 'Đặt lại mật khẩu',
    getPasswordResetLink: 'Nhận liên kết đổi mật khẩu',
    forgotPasswordDesc:
      'Bạn sẽ nhận được liên kết để đặt lại mật khẩu qua số điện thoại đang dùng để đăng nhập',
    checkYourPhone: 'Liên kết đặt lại mật khẩu đã được gửi đến bạn',
    resendPasscodeDescBefore:
      'Vui lòng truy cập vào liên kết được gửi đến số điện thoại ',
    resendPasscodeDescAfter: ' để đặt lại mật khẩu.',
    didNotReceive: 'Bạn không nhận được liên kết?',
    resendLink: 'Gửi lại liên kết',
    resendLinkIn: 'Gửi lại liên kết sau ',
    changePhoneNumber: 'Thay đổi số điện thoại',
    failedToAuthenticateOtp: 'Xác minh OTP thất bại',
    failedToAuthenticateOtpContent:
      'Bạn đã nhập sai OTP 5 lần liên tiếp. Vì lý do bảo mật, bạn không thể đăng nhập ở thời điểm này. Vui lòng thử lại sau ',
    yourAccountIsLocked: 'Tài khoản đã bị khóa',
    yourAccountIsLockedContent:
      'Bạn đã nhập sai mật khẩu 5 lần liên tiếp. Để đăng nhập lại, bạn cần đặt lại mật khẩu bằng cách truy cập vào liên kết được gửi đến số điện thoại đang dùng để đăng nhập.',
    enterNewPassword: 'Nhập mật khẩu mới',
    reEnterPassword: 'Nhập lại mật khẩu',
    rePasswordNotMatch: 'Mật khẩu không trùng khớp. Vui lòng thử lại.',
    reset: 'Đặt lại',
    areYouSureYouWantToLogout: 'Bạn có chắc muốn đăng xuất tài khoản?',
    loginMethodNotAvailable:
      'Phương thức đăng nhập hiện không khả dụng, vui lòng thử lại sau',
    createPasscodeTitle: 'Tạo mật khẩu',
    createPasscodeDescription:
      'Hãy tạo mật khẩu để tăng bảo mật cho tài khoản của bạn.',
    confirmPasscodeTitle: 'Xác nhận mật khẩu',
    confirmPasscodeDescription: 'Hãy nhập lại mật khẩu bạn vừa tạo.',
    loginWithOTP: 'Đăng nhập bằng OTP',
    skip: 'Bỏ qua',
    wrongPasscodeExceededLimit:
      'Bạn đã nhập sai mật khẩu {{count}} lần. Vui lòng nhập mã gồm 4 chữ số đã được gửi đến số điện thoại ',
    contactWithCustomerSupport: 'Liên hệ CSKH',
  },
  en: {
    login: 'Login',
    logout: 'Logout',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signOut: 'Sign out',
    loginWithGoogle: 'Login with Google',
    loginWithFacebook: 'Login with Facebook',
    loginWithUsername: 'Log in with Username',
    loginWithPhoneNumber: 'Log in with Phone number',
    enterOTP: 'Enter OTP',
    zaloOtpNote:
      'Write the 4-digit code sent to your Zalo account linked with the phone number',
    smsOtpNote: 'Write the 4-digit code sent to your phone via SMS',
    sentOtpNote: 'We’ve sent an OTP to ',
    resendOtpIn: 'Resend OTP in ',
    didNotReceiveOtp: 'Didn’t get the OTP',
    resendOtp: 'Resend OTP',
    loggingInWithPhoneNumber: 'Logging in with the phone number ',
    username: 'Username',
    password: 'Password',
    phoneNumber: 'Phone number',
    enterYourPhoneNumber: 'Enter your phone number',
    fullName: 'Full name',
    chooseYourAccountType: 'Choose your account type',
    referralCode: 'Referral code',
    conditionAndPolicyMessage:
      "By signing up, you agree to our <a target='_blank' href='https://ahamove.com/pages/policy' title='{{terms}}' >{{terms}}</a>",
    termsAndConditions: 'Terms and Conditions',
    namePlaceholder: 'Contact name when using our service',
    phonePlaceholder: 'Driver will contact you at this number',
    emailPlaceholder: "We'll send you important updates by email",
    optional: 'optional',
    referralPlaceholder: 'Enter your code to earn rewards',
    privacyPolicyAndTermsOfService: 'By signing up, you agreed to our ',
    privacyPolicyAndTermsOfServiceLink: 'Privacy Policy and Terms of Service',
    thisAccountDoesNotExist: 'This account does not exist',
    thisAccountDoesNotExistHintPhoneNumber: 'The phone number',
    thisAccountDoesNotExistHintQuestion:
      'you entered was not registered yet. would you like to sign up with it?',
    requiredPhoneNumber: 'Phone number is required',
    invalidPhoneNumber: 'Invalid phone number',
    requiredEmail: 'Email is required',
    requiredName: 'Name is required',
    yourTokenHasExpiredPleaseSignInAgain:
      'Your token has expired, please sign in again.',
    yourTokenHasExpired: 'Your token has expired.',
    youAreNotLoggedInYet: 'You are not logged in yet!',
    pleaseLogInToContinue: 'Please log in to continue.',
    enterPassword: 'Enter password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    resetYourPassword: 'Reset your password',
    getPasswordResetLink: 'Get password reset link',
    forgotPasswordDesc:
      "You'll receive a link to reset your password via the phone number you're using to log in",
    checkYourPhone: 'We’ve sent you a link to reset your password',
    resendPasscodeDescBefore: 'Click the link sent to the phone number ',
    resendPasscodeDescAfter: ' to reset your password',
    didNotReceive: 'Didn’t get the link?',
    resendLink: 'Resend link',
    resendLinkIn: 'Resend link in ',
    changePhoneNumber: 'Change phone number',
    failedToAuthenticateOtp: 'Failed to authenticate OTP',
    failedToAuthenticateOtpContent:
      "You have entered incorrect OTP codes 5 consecutive times. To keep your account safe, you can't log in at the moment. Please try again after ",
    yourAccountIsLocked: 'Your account is locked',
    yourAccountIsLockedContent:
      "You've entered the incorrect password 5 times. To log in again, you’ll need to reset your password using the link sent to the phone number you're using to log in.",
    enterNewPassword: 'Enter new password',
    reEnterPassword: 'Re-Enter new password',
    rePasswordNotMatch: 'The input is not match, please try again',
    reset: 'Reset',
    areYouSureYouWantToLogout: 'Are you sure you want to sign out?',
    loginMethodNotAvailable:
      'The login method is currently unavailable, please try again later',
    createPasscodeTitle: 'Create passcode',
    createPasscodeDescription:
      'Create a password to increase security and log in faster next time.',
    confirmPasscodeTitle: 'Confirm passcode',
    confirmPasscodeDescription:
      'Please re-enter the password you just created.',
    loginWithOTP: 'Login with OTP',
    skip: 'Skip',
    wrongPasscodeExceededLimit:
      'Bạn đã nhập sai mật khẩu {{count}} lần. Vui lòng nhập mã gồm 4 chữ số đã được gửi đến số điện thoại',
    contactWithCustomerSupport: 'Contact with customer support',
  },
};

export type AuthLocales = typeof authLocales;
